import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import _ from 'lodash';
import { first } from 'rxjs/operators';
import { BancoResponse } from 'src/app/global/interfaces/banco-response';
import { clipBoardI, clipBoardIPJ } from 'src/app/global/interfaces/cuenta-abono.response';
import { Paso1Login } from 'src/app/global/interfaces/paso-1-login';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { TipoCuenta } from 'src/app/global/interfaces/tipo-cuenta';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { CuentaAbonoSubject } from 'src/app/global/services/cuenta-abono-subject.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { cuentaBancaria, rut } from 'src/app/messages/step-2-messages';
import { BancoServiceVM } from 'src/app/view-model/services/banco-vm.service';
import { CuentaAbonoServiceVM } from 'src/app/view-model/services/cuenta-abono-vm.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { ValidacionEdicionServiceVM } from 'src/app/view-model/services/validacion-edicion.service';
import { rutEmpresaValidator } from 'src/app/view-model/validators/rutempresa.validator';
import { rutGenericoValidator } from 'src/app/view-model/validators/rutgenerico.validator';

@Component({
  selector: 'app-abonos-pj',
  templateUrl: './abonos-pj.component.html',
  styleUrls: ['./abonos-pj.component.scss']
})
export class AbonosPJComponent implements OnInit {

  private runBeforeTitular: string;
  public bloquearBtnGuardar: boolean;
  public bloquearInputs: boolean;
  public dataPaso1: Paso1Login;
  public dataPaso3: Paso3;
  public dataTipoCuenta: any;
  public datosBanco: any;
  public desplegarInfoempresa = false;
  public errorRut = rut;
  public finalRut: string;
  public formAbonos: FormGroup;
  public imgBanco: string;
  public isCuentaEmpresa: boolean;
  public isCuentaPropia: boolean;
  public loading = false;
  public loadingCuenta: boolean;
  public mensaje: string;
  public mensajeErrorCuentaBancaria = cuentaBancaria;
  public mostrarBanco = true;
  public panelOpenState = false;
  public puedeEditar: boolean;
  public razonSocialStr: string;
  public rutEmpresa: string;
  public screenSize;
  public showEdCuenta: boolean;
  disableNumeroCuenta = false;
  bancos: BancoResponse[] = [];
  tiposCuenta:TipoCuenta[] = [];
  tiposCuentasDefinidos:TipoCuenta[] = [];
  public isEmpresa: boolean;
  private hasRun: boolean = false;
  dataParsedClipboard: clipBoardIPJ;
   private primerClick = true;
   private isFromClipboard: boolean = false;

  @HostListener('window:resize', ['$event'])
  cambiaAnchura() {
    this.screenSize = window.innerWidth;
  }
  get showBanco(): boolean {
    return this.screenSize >= 960;
  }

  constructor(
    private cuentaAbonoService: CuentaAbonoServiceVM,
    private cuentaAbonoSubject: CuentaAbonoSubject,
    private bancoService: BancoServiceVM,
    private localStorageService: LocalStorageService,
    private rutFormatter: RutFormatterService,
    private valEdicionService: ValidacionEdicionServiceVM,
    private dialogService: DialogService,
    private tagManagerService: TagManagerService) {

    }

  ngOnInit() {
    this.dataPaso1 = this.localStorageService.getPaso1Login();
    this.dataPaso3 = this.localStorageService.getPaso3();
    this.cargarBancos();
   
    this.datosBanco = this.dataPaso3.bancos;
    this.puedeEditar = this.dataPaso3.validaPaso3.data;
    this.screenSize = window.innerWidth;
    this.showEdCuenta = false;
    this.bloquearInputs = true;
    this.bloquearBtnGuardar = true;
    this.loadingCuenta = true;
    this.crearFormulario();
    this.cambioBanco();
    this.selTipoCuenta();
    this.setInitialParameters();
    this.formAbonos.get('banco').valueChanges.subscribe(bancoId => {
      this.cambioBanco();
    });
  }

  setInitialParameters() {
    if (this.dataPaso3.dataCuentaAbono.tipoPropietario === 'PROPIA') {
      this.isCuentaPropia = true;
      this.bloquearInputs = true;
      this.isCuentaEmpresa = true;
      this.desplegarInfoempresa = true;
    }

    if (this.dataPaso3.dataCuentaAbono.run >= 50000000 && this.dataPaso3.dataCuentaAbono.tipoPropietario === 'TERCERO') {
      this.isCuentaEmpresa = true;
      this.desplegarInfoempresa = true;
    }

    if (this.dataPaso3.dataCuentaAbono.run < 50000000 && this.dataPaso3.dataCuentaAbono.tipoPropietario === 'TERCERO') {
      this.isCuentaEmpresa = false;
      this.desplegarInfoempresa = false;
    }

    this.valEdicionService.getValidacion$.subscribe(resp => {
      if (resp !== null) {
        this.puedeEditar = resp;
        this.dataPaso3.validaPaso3.data = resp;
      }
    });

    this.imgBanco = 'assets/images/bancos/' + this.dataPaso3.dataCuentaAbono.banco.id + '.png';
    const rut = this.dataPaso1.run.toString().replace(/\./g, '').replace(/-/g, '');
    this.rutEmpresa = `${rut}`;
    this.razonSocialStr = this.dataPaso3.datosComercio.razonSocial;
  }

  get tipoCuenta() { return this.formAbonos.get('tipoCuenta'); }
  get rutTitular() { return this.formAbonos.get('rutTitular'); }
  get nombres() { return this.formAbonos.get('nombres'); }
  get primerApellido() { return this.formAbonos.get('primerApellido'); }
  get segundoApellido() { return this.formAbonos.get('segundoApellido'); }
  get banco() { return this.formAbonos.get('banco'); }
  get tipoCuentaBanco() { return this.formAbonos.get('tipoCuentaBanco'); }
  get numeroCuenta() { return this.formAbonos.get('numeroCuenta'); }
  get verificado() { return this.formAbonos.get('verificado'); }

  /**
   * Solo carga al inicio del componente de abono Paso 3, dirimiendo entre mostrar Form asociado a cuenta empres o tercero
   */
  private crearFormulario() {
    const rutDv = this.rutFormatter.getDv(this.dataPaso3.dataCuentaAbono.run);
    this.finalRut = this.rutFormatter.format(this.dataPaso3.dataCuentaAbono.run + '-' + rutDv).toUpperCase();

    if (this.dataPaso3.dataCuentaAbono.tipoPropietario === 'PROPIA') {
      this.mensaje = 'Recibirás los abonos en una cuenta que está a nombre de tu empresa';
      this.formAbonos = this.formCuentaPropia(this.finalRut);
      //this.selTipoCuenta();
    } else if (this.dataPaso3.dataCuentaAbono.tipoPropietario === 'TERCERO') {
      this.mensaje = 'Recibirás los abonos en una cuenta distinta que no esté a nombre de tu empresa';
      this.formAbonos = this.formCuentaTercero(this.finalRut);
    }
  }

  cargarBancos() {
    this.bancoService.getBancos().subscribe(
      bancos => {
        this.datosBanco = this.cambiaNombreCuentaBancos(bancos);  
        this.tiposCuentasDefinidos = bancos
          .map(b => b.relacion)
          .reduce((acc, val) => acc.concat(val), []);  
      },
      error => console.error('Error al cargar los bancos:', error)  
    );
  }

  cambiaNombreCuentaBancos(bancos: BancoResponse[]){
    //Banco de Chile
    var indexBanco = bancos.findIndex((b => b.id === 24))
    var indexRelacion = bancos[indexBanco].relacion.findIndex ((r => r.id = "CORRIENTE"));
    bancos[indexBanco].relacion[indexRelacion].descripcion = "Cuenta Corriente / Cuenta Vista";

    //Banco BCI
    indexBanco = bancos.findIndex((b => b.id === 2))
    indexRelacion = bancos[indexBanco].relacion.findIndex ((r => r.id = "CORRIENTE"));
    bancos[indexBanco].relacion[indexRelacion].descripcion = "Cuenta Corriente / Cuenta Vista";
    return bancos;
  }

  recargarBancos(bancoId: number): void {
    const bancoSeleccionado = this.bancos.find(b => Number(b.id) === Number(bancoId));
    if (bancoSeleccionado) {
      this.tiposCuenta = bancoSeleccionado.relacion;
    } else {
      this.tiposCuenta = [];
    }
  }

  public habilitarSeccionDatos() {
    if (this.showEdCuenta) {
      this.showEdCuenta = false;
      this.mostrarBanco = true;
    } else {
      this.showEdCuenta = true;
      this.desplegarInfoBanco();
      this.tagManagerService.logEditaCuentaAbono();
      this.tagManagerService.logEvent(GoogleTagManager.eventInteracciones().categoriaDetalleContratacion().accionClick().setEtiqueta("Editar"))
    }
  }

  private desplegarInfoBanco() {
    if (this.showBanco) {
      this.mostrarBanco = true;
    } else {
      this.mostrarBanco = false;
    }
  }

  public cambioBanco() {
    if (this.banco.value !== '') {
      const rut = this.rutFormatter.format(this.rutTitular.value);
      if (Number(this.banco.value) === 12 && this.rutFormatter.getRutFormats(rut).numbers >= 50000000) {
        this.dataTipoCuenta = [];
        this.dataTipoCuenta[0] = _.find(this.datosBanco, ['id', Number(this.banco.value)]).relacion[0];
      } else {
        this.dataTipoCuenta = _.find(this.datosBanco, ['id', Number(this.banco.value)]).relacion;
      }
    } else {
      this.dataTipoCuenta = [];
    }
  }

  private selTipoCuenta() {

    if (this.dataTipoCuenta.length === 0) {
      return;
    }
    const data = _.find(this.dataTipoCuenta, ['id', this.dataPaso3.dataCuentaAbono.banco.relacion[0].id]);
    this.tipoCuentaBanco.setValue(data.id);
  }

  public verificarTipoCuenta() {
    let rutDv = this.rutFormatter.getDv(this.dataPaso3.dataCuentaAbono.run);
    let finalRut = this.rutFormatter.format(this.dataPaso3.dataCuentaAbono.run + '-' + rutDv);
    if (this.tipoCuenta.value === 'TERCERO') {
      this.mensaje = 'Recibirás los abonos en una cuenta distinta que no esté a nombre de la empresa';
      this.formAbonos = this.formCuentaTercero(finalRut);
      this.bloquearInputs = false;
      this.runBeforeTitular = this.formAbonos.get('rutTitular').value;
      this.selTipoCuenta();
      // this.cuentaAbonoSubject.showAnexoContrato();
    } else {
      rutDv = this.rutFormatter.getDv(Number(this.rutEmpresa));
      finalRut = this.rutFormatter.format(Number(this.rutEmpresa) + '-' + rutDv);
      this.formAbonos = this.formCuentaPropia(finalRut);
      this.bloquearInputs = true;
      this.mensaje = 'Recibirás los abonos en una cuenta de la empresa';
      this.rutTitular.setValue(finalRut.toUpperCase());
      //this.razonSocial.setValue(this.dataPaso3.datosComercio.razonSocial);
      this.nombres.setValue(this.dataPaso3.datosComercio.razonSocial);


      if (this.dataPaso3.dataCuentaAbono.tipoPropietario === 'TERCERO') {
       // this.banco.setValue('');
        //this.tipoCuentaBanco.setValue('');
        //this.numeroCuenta.setValue('');
      } else {
        this.cambioBanco();
      }
      this.isCuentaEmpresa = true;
      // this.cuentaAbonoSubject.showTerminosyCondiciones();
    }
  }

   // Carga los datos paso 1
    private async loadData(): Promise<void> {
      // Pegar el rut, nombre, apellidos login
      //this.formAbonos.get('rut').setValue(this.runLogin);
      const nombresLogin = this.dataPaso3.datosComercio.razonSocial;
      this.formAbonos.get('nombres').setValue(nombresLogin);
      this.formAbonos.get('primerApellido').setValue('');
      this.formAbonos.get('segundoApellido').setValue('');
      this.tipoCuentaBanco.setValue('');
      this.numeroCuenta.reset;
      this.banco.setValue('');
      }



  determineCuentainit(): void {
    // Procesar y validar el RUT ingresado
    const runBody = this.getRutBodyIfValid(String(this.rutTitular.value))
    // Procesar y validar el RUT de login
    const rutlogBody = this.dataPaso3.dataCuentaAbono.run

    // Convertir los cuerpos del RUT a números enteros
    const run = parseInt(String(runBody), 10);
    const rutlog = parseInt(String(rutlogBody), 10);

    // Lógica para determinar el tipo de cuenta
    switch (true) {
      // Caso 1: Cuenta Propia
      case rutlog === run:
        this.tipoCuenta.setValue('PROPIA');
        console.warn("Soy PROPIA");
        this.isCuentaPropia = true;
        this.bloquearInputs = true;
        this.isCuentaEmpresa = true;
        this.desplegarInfoempresa = true;
        this.limpiarCampos() 
        break;

      // Caso 2: Cuenta Empresa
      case run >= 50000000:
        this.tipoCuenta.setValue('TERCERO');
        console.warn("Soy EMPRESA")
        this.isCuentaEmpresa = true;
        this.desplegarInfoempresa = false;
        //this.formCuentaTercero;
        this.limpiarCampos() 
        break;

      // Caso 3: Cuenta Terceros
      case run !== rutlog && run < 50000000:
        this.tipoCuenta.setValue('TERCERO');
        console.warn("soy Terceros");
        this.bloquearInputs = false;
        this.isCuentaEmpresa = false;
        //this.formCuentaTercero;
        this.limpiarCampos() 
        break;

      default:
        console.error("RUT no válido");
        break;
    }
  }


  private determineCuentachange(): void {
   /*  if (this.esComercioInformal) {
      console.warn("No se ejecuta determineCuentachange porque esComercioInformal es true");
      return;
    } */
  
    console.warn("Entró al método determineCuentachange");
    const rut = this.formAbonos.get('rutTitular').value;
  
    // Convertir el RUT del input y el runLogin a números enteros
    const run = parseInt(rut.split('-')[0].replace(/\D/g, ''), 10);
    const rutlog = this.rutEmpresa.toLowerCase().endsWith('k')
    ? parseInt(this.rutEmpresa.slice(0, -1).replace(/\D/g, ''), 10)
    : parseInt(this.rutEmpresa.replace(/\D/g, '').slice(0, -1), 10);
  
  
    // Lógica para determinar el tipo de cuenta
    switch (true) {
      // Caso 1: Cuenta Propia
      case rutlog === run:
        console.warn("Es una Cuenta Propia / processing = true ");
        this.formAbonos.get('PROPIA') as FormGroup;
        this.tipoCuenta.setValue('PROPIA');
        this.formCuentaPropia;
        this.formAbonos.get('rutTitular').setValue(rut, { emitEvent: false });
        this.loadData();
        this.formAbonos.get('primerApellido').setValue('VACIO');
        this.formAbonos.get('segundoApellido').setValue('VACIO');
        this.isCuentaPropia = true;
        this.bloquearInputs = true;
        this.isCuentaEmpresa = true;
        this.desplegarInfoempresa = true;
        this.isCuentaRut();
        break;
  
      // Caso 2: Cuenta Empresa
      case run >= 50000000:
        console.warn("Es una Cuenta Empresa");
        this.formAbonos.get('TERCERO') as FormGroup;
        this.tipoCuenta.setValue('TERCERO');
        this.formAbonos.get('rutTitular').setValue(rut, { emitEvent: false });
        this.isEmpresa = true;
        this.desplegarInfoempresa = true;
        this.bloquearInputs = false;
        this.isRutEmpresa();
        this.formCuentaTercero;
        this.limpiarCampos();
         // Si los datos provienen del portapapeles, los inyectamos en el formulario:
         if (this.isFromClipboard && this.dataParsedClipboard) {
          this.confirmClipboad(this.dataParsedClipboard);
          this.dataParsedClipboard = null;
          this.isFromClipboard = false;
        }
          console.log("Valores del form luego de confirmClipboad:", this.formAbonos.value);
        break;
  
      // Caso 3: Cuenta Terceros
      case run !== rutlog && run < 50000000:
        console.warn("Es una Cuenta de Terceros");
        this.formAbonos.get('TERCERO') as FormGroup;
        this.tipoCuenta.setValue('TERCERO');
        this.formAbonos.get('rutTitular').setValue(rut, { emitEvent: false });
        this.bloquearInputs = false;
        this.isCuentaEmpresa = false;
        this.desplegarInfoempresa = true;
        this.formCuentaTercero;
        this.limpiarCampos();
         // Si los datos provienen del portapapeles, los inyectamos en el formulario:
         if (this.isFromClipboard && this.dataParsedClipboard) {
          this.confirmClipboad(this.dataParsedClipboard);
          this.dataParsedClipboard = null;
          this.isFromClipboard = false;
        }
        console.log("Valores del form luego de confirmClipboad:", this.formAbonos.value);
        break;
  
      default:
        console.error("RUT no válido");
        this.bloquearInputs = false;
        //this.esComercioInformal = false;
        break;
    }
  }

  private getRutBodyIfValid(rut: string): string {
    // Eliminar todos los caracteres que no sean dígitos o 'K'
    const cleanRut = rut.replace(/[^0-9kK]/g, '');
    // Separar el cuerpo del RUT y el dígito verificador
    const body = cleanRut.slice(0, -1);
    const dv = cleanRut.slice(-1).toUpperCase();

    // Validar que el cuerpo del RUT tenga al menos un dígito
    if (body.length < 1) {
        throw new Error("El RUT proporcionado es demasiado corto");
    }

    // Calcular el dígito verificador esperado
    const expectedDv = this.rutFormatter.getDv(Number(body)).toString().toUpperCase();

    // Validar el dígito verificador
    if (expectedDv !== dv) {
        throw new Error(`Dígito verificador incorrecto para el RUT ${rut}`);
    }

    // Retornar el cuerpo del RUT si es válido
    return body;
}

  public verCheck() {
    console.log(this.formAbonos);
  }

  private limpiarCampos() {
    this.nombres.setValue('');
    this.primerApellido.setValue('');
    this.segundoApellido.setValue('');
    this.tipoCuentaBanco.setValue('');
    this.numeroCuenta.setValue('');
    this.banco.setValue('');
  }

  public onRutFocusOut() {
    if (this.rutTitular.valid) {
      if (this.validRunEqual() && this.tipoCuenta.value !== 'PROPIA') {
        const dialogRef = this.dialogService.openRutPerteneceAPropiaDialog();
        dialogRef.afterClosed().subscribe(resp => {
          if (resp.action === 'OK') {
            this.tipoCuenta.setValue('PROPIA');
            this.verificarTipoCuenta();
          } else {
            this.tipoCuenta.setValue('TERCERO');
            //this.rutTitular.setValue('');
          }
        });
      } else {
        this.isRutEmpresa();
      }
    }
  }

  private validRunEqual(): boolean {
    return (String(this.rutTitular.value).toUpperCase() === this.rutFormatter.getRutFormats(this.rutEmpresa).full);
  }

  private isRutEmpresa() {
    if (this.rutFormatter.getRutFormats(this.rutTitular.value).numbers >= 50000000) {
      const dialogRef = this.dialogService.openRutPerteneceAEmpresaDialog();
      dialogRef.afterClosed().subscribe(resp => {
        if (resp.action === 'OK') {
          this.isCuentaEmpresa = true;
          //this.limpiarCampos();
          this.nombres.setValue('');
          this.primerApellido.setValue('NO APLICA');
          this.segundoApellido.setValue('NO APLICA');
        } else {
          //this.rutTitular.setValue('');
          
        }
      });
    } else if (!this.validRunEqual() && this.rutTitular.value !== this.runBeforeTitular) {
      this.isCuentaEmpresa = false;
      this.limpiarCampos();
    }
  }

  /**
   * Este metodo siempre tiene como rut titular un rut empresa. ergo tambien asociado una razon social
   * @param finalRut Rut empresa asociado a la Cuenta de abono
   * @returns 
   */
  private formCuentaPropia(rutEmpresa: string): FormGroup {
    const dv = this.rutFormatter.getDv(Number(rutEmpresa)).toString().toUpperCase();
    const rut = this.rutFormatter.format(rutEmpresa + '-' + dv);
    return new FormGroup({
      tipoCuenta: new FormControl('PROPIA', [Validators.required]),
      rutTitular: new FormControl(rut, [Validators.required, rutGenericoValidator]),
      nombres: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'razonSocial'), [Validators.required, Validators.pattern('^[a-zA-ZñÑ ]+$')]),
      primerApellido: new FormControl('NO APLICA', [Validators.required, Validators.pattern('^[a-zA-ZñÑ ]+$')]),
      segundoApellido: new FormControl('NO APLICA', [Validators.pattern('^[a-zA-ZñÑ ]+$')]),
      banco: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'banco.id'), [Validators.required]),
      tipoCuentaBanco: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'banco.relacion[0].id'), [Validators.required]),
      numeroCuenta: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'numero'), [Validators.required]),
      verificado: new FormControl(false, Validators.requiredTrue)
    });
  }

  /**
   * Este metodo genera formulario para cuenta de terceros, ya sea rut empresa o persona natural de terceros
   * @param finalRut Rut asociado a la Cuenta de abono
   * @returns 
   */
  private formCuentaTercero(finalRut: string): FormGroup {
    if (this.dataPaso3.dataCuentaAbono.tipoPropietario === 'TERCERO') {
      if (this.dataPaso3.dataCuentaAbono.run < 50000000) {
        return new FormGroup({
          tipoCuenta: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'tipoPropietario'), [Validators.required]),
          rutTitular: new FormControl(finalRut, [Validators.required, rutGenericoValidator]),
          nombres: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'nombre.nombres'), [Validators.required, Validators.pattern('^[a-zA-ZñÑ ]+$')]),
          primerApellido: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'nombre.apellidoPaterno'), [Validators.required, Validators.pattern('^[a-zA-ZñÑ ]+$')]),
          segundoApellido: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'nombre.apellidoMaterno'), [Validators.pattern('^[a-zA-ZñÑ ]+$')]),
          banco: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'banco.id'), [Validators.required]),
          tipoCuentaBanco: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'banco.relacion[0].id'), [Validators.required]),
          numeroCuenta: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'numero'), [Validators.required]),
          verificado: new FormControl(false, Validators.requiredTrue)
        });

      } else {
        this.isCuentaEmpresa = true;
        this.desplegarInfoempresa = true;
        return new FormGroup({
          tipoCuenta: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'tipoPropietario'), [Validators.required]),
          rutTitular: new FormControl(finalRut, [Validators.required, rutGenericoValidator]),
          nombres: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'razonSocial'), [Validators.required, Validators.pattern('^[a-zA-ZñÑ ]+$')]),
          primerApellido: new FormControl('NO APLICA', [Validators.required, Validators.pattern('^[a-zA-ZñÑ ]+$')]),
          segundoApellido: new FormControl('NO APLICA', [Validators.pattern('^[a-zA-ZñÑ ]+$')]),
          banco: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'banco.id'), [Validators.required]),
          tipoCuentaBanco: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'banco.relacion[0].id'), [Validators.required]),
          numeroCuenta: new FormControl(_.get(this.dataPaso3.dataCuentaAbono, 'numero'), [Validators.required]),
          verificado: new FormControl(false, Validators.requiredTrue)
        });
      }
    } else {
      this.dataTipoCuenta = [];
      return new FormGroup({
        tipoCuenta: new FormControl('TERCERO', [Validators.required]),
        rutTitular: new FormControl('', [Validators.required, rutGenericoValidator]),
        nombres: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-ZñÑ ]+$')]),
        primerApellido: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-ZñÑ ]+$')]),
        segundoApellido: new FormControl('', [Validators.pattern('^[a-zA-ZñÑ ]+$')]),
        banco: new FormControl('', [Validators.required]),
        tipoCuentaBanco: new FormControl('', [Validators.required]),
        numeroCuenta: new FormControl('', [Validators.required]),
        verificado: new FormControl(false, Validators.requiredTrue)
      });
    }
  }

  isCuentaRut() {
    if (Number(this.banco.value) === 12 && this.tipoCuentaBanco.value === 'RUT') {
      const cuentaRut = this.rutFormatter.getRutFormats(this.rutTitular.value).numbers;
      this.numeroCuenta.setValue(cuentaRut);
      //this.disableNumeroCuenta = true;
    } else {
      this.numeroCuenta.setValue('');
      //this.disableNumeroCuenta = false;
    }
  }

  public guardarCuentaAbono() {
    this.loading = true;

    const cbOK = response => {
      this.dataPaso3.dataCuentaAbono = response.cuentaAbono;
      this.dataPaso3.tipoAprobacion.tipoAprobacion = response.tipoAprobacion;
      this.localStorageService.setPaso3(this.dataPaso3);
      
      this.setInitialParameters();

      this.loading = false;

      this.habilitarSeccionDatos();
      if (response.tipoAprobacion === 'FIRMA_ELECTRONICA') {
        this.cuentaAbonoSubject.showAnexoContrato();
      } else {
        this.cuentaAbonoSubject.showTerminosyCondiciones();
      }
    };

    const cbError = error => {
      this.loading = false;
      console.error(error);
    };
    this.cuentaAbonoService.postCuentaAbonoPaso3(this.formAbonos).subscribe(cbOK, cbError);
  }



  /* Modal init */

  abrirModal(): void {
    if (this.primerClick) {
      ($('#clipboardModal') as any).modal('show'); 
      this.primerClick = false; 
    } else {
      ($('#clipboardModal') as any).modal('hide'); 
      this.primerClick = true;
    }
  }


  cerrarModal() {
    console.warn('Permitir acceso al portapapeles');
    ($('#clipboardModal') as any).modal('hide'); 
    this.modalCopiardatos();
    //this.determineCuentainit();  
  }


  levantaInput() {
    if (this.hasRun) {
      return;
    }
    this.modalCopiardatos();
    this.hasRun = true;
  }


  /* Modal pegar */
  modalCopiardatos() {
    navigator.clipboard.readText().then((text) => {
      const dataParsed = this.parseClipboardText(text); 
      this.isFromClipboard = true;

      const data = {
        title: 'Copia y pega tus datos bancarios',
        description: `
        <strong>Activa y usa los datos desde el portapapeles</strong> <br><br>
        Para activar la función pegar datos bancarios, presiona el botón Permitir que aparece arriba en tu navegador. <br><br>
        <strong>¿Deseas utilizar estos datos?</strong><br><br>
        <div class="card cardcuenta" style="width: 18rem;">
        <div class="card-body">
        <table class="table table-sm table-borderless" style="width:100%;">
          <tr>
            <td style="  padding: 8px;">Nombre</td>
            <td style="  padding: 8px;">${dataParsed.razonSocial ? dataParsed.razonSocial : 'No disponible'}</td>
          </tr>
         
          <tr>
            <td style="  padding: 8px;">RUT</td>
            <td style="  padding: 8px;">${dataParsed.rutEmpresa ? dataParsed.rutEmpresa : 'No disponible'}</td>
          </tr>
          <tr>
            <td style="  padding: 8px;">Cuenta</td>
            <td style="  padding: 8px;">${dataParsed.cuenta ? dataParsed.cuenta : 'No disponible'}</td>
          </tr>
          <tr>
            <td style="  padding: 8px;">Banco</td>
           <td style="  padding: 8px;">${dataParsed.banco && dataParsed.banco.descripcion ? dataParsed.banco.descripcion : 'No disponible'}</td>
          </tr>
          <tr>
            <td style="  padding: 8px;">Tipo de Cuenta</td>
            <td style="  padding: 8px;">${dataParsed.tipoCuenta ? dataParsed.tipoCuenta.descripcion : 'No disponible'}</td>
          </tr>
        </table></div></div><br><br>
      `,
        cancelButton: 'No por ahora',
        actionButton: 'Si, utilizar'
      };

      this.dialogService.openTwoActionsDialog({ data }).afterClosed().subscribe(async (action) => {
        if (action.action === 'OK') {
          this.confirmClipboad(dataParsed);
          this.determineCuentachange();
        }
      });
    }).catch(err => {
      console.error('Failed to read clipboard contents: ', err);
    });
  }


  private runEsEmpresa(rut: number) {
    return rut >= 50000000;
  }

  private confirmClipboad(dataParsed:clipBoardIPJ){

    this.formAbonos.get('banco').valueChanges.pipe(first()).subscribe(()=>{
      this.formAbonos.get('tipoCuentaBanco').setValue(dataParsed.tipoCuenta.id);
    });
    this.formAbonos.get('rutTitular').setValue(dataParsed.rutEmpresa);
    const run =dataParsed.rutEmpresa.split('-')[0]? Number(dataParsed.rutEmpresa.split('-')[0].split('.').join('')):0
    this.formAbonos.get('nombres').setValue(this.runEsEmpresa(run)? dataParsed.razonSocial:dataParsed.nombre.nombresTitular);
    this.formAbonos.get('primerApellido').setValue(dataParsed.nombre.primerApellido);
    this.formAbonos.get('segundoApellido').setValue(dataParsed.nombre.segundoApellido);
    this.formAbonos.get('banco').setValue(dataParsed.banco.id);
    this.formAbonos.get('tipoCuentaBanco').setValue(dataParsed.tipoCuenta.id);
    this.formAbonos.get('numeroCuenta').setValue(dataParsed.cuenta);
 }


/* Modal pegar */
modalConfirmardatos() {
  // Obtén los valores del formulario
  const dataParsed = this.formAbonos.value;
  const bancoID =Number(dataParsed.bancos);

  const bancoElegido =this.bancos.find(banco=>banco.id===bancoID);
  const tipCuentaElegida =this.tiposCuenta.find(tipoCuenta=>tipoCuenta.id===dataParsed.tipoCuenta);

  const data = {
    title: 'Confirmación de datos',
    description: `Revisa y confirma que los datos ingresados son correctos antes de continuar. <br><br>
      <div class="alert  border rounded" role="alert">
      <div class="mr-2 infoicon"> </div>
      El abono de tu dinero no será efectuado, si estos datos no corresponden a una cuenta bancaria, existente y con vigencia.
      </div>
      <div class="card cardcuenta" style="width: 18rem;">
        <div class="card-body">
          <table class="table table-sm table-borderless" style="width:100%;">
            <tr>
              <td style="padding: 8px;">Nombre</td>
              <td style="padding: 8px;">${dataParsed.nombresTitular ? dataParsed.nombresTitular : 'No disponible'}</td>
            </tr>
           
            <tr>
              <td style="padding: 8px;">RUT</td>
              <td style="padding: 8px;">${dataParsed.rut ? dataParsed.rut : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Cuenta</td>
              <td style="padding: 8px;">${dataParsed.numeroCuenta ? dataParsed.numeroCuenta : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Banco</td>
              <td style="padding: 8px;">${bancoElegido ? bancoElegido.asString : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Tipo de Cuenta</td>
              < <td style="padding: 8px;">${tipCuentaElegida ? tipCuentaElegida.descripcion : 'No disponible'}</td>
            </tr>
          </table>
        </div>
      </div><br><br>
    `,
    cancelButton: 'Editar datos',
    actionButton: 'Confirmar'
  };

  this.dialogService.openTwoActionsDialog({ data }).afterClosed().subscribe(async (action) => {
    if (action && action.action  === 'OK') {
      this.loading = true;
      this.guardarCuentaAbono();
    }
  });
}

  /* método para copiar y pegar */
  getClipboard() {
    navigator.clipboard.readText()
      .then((text) => {
        console.log('clipboard contents', text);
        this.parseClipboardText(text);
      })
      .catch(err => {
        console.error('Failed to read clipboard contents: ', err);
      });
  }

  /* Función para analizar el texto del portapapeles */
  private parseClipboardText(text: string) {
    const lines = text.split('\n');
    const dataParsed:clipBoardIPJ = {
        nombre : {
          nombresTitular: '',
          primerApellido:'',
          segundoApellido: ''
        },
      razonSocial: '',
      mail: '',
      rutEmpresa: '',
      cuenta: '',
      banco:{
        id: 0,
        descripcion:''
    } ,
    tipoCuenta: undefined
    };

    console.log(lines);
    console.log('---------------');

    // Procesa cada línea para extraer la información requerida
    //const cuenta = this.form.get('seleccionarCuenta').value;
    dataParsed.rutEmpresa = this.getRutClip(lines);
    // const run =  dataParsed.rutEmpresa.split('-')[0].split('.').join('');
    // run >= 50000000
    // if(cuenta == 'CUENTA_TERCEROS'){
    dataParsed.nombre= this.getNombresYApellidos(lines);
    // }else{
    dataParsed.razonSocial= this.getRazonSocial(lines);
    // }
    // dataParsed.mail = this.getMailClip(lines);
    dataParsed.cuenta = this.getCuentaClip(lines);
    dataParsed.banco = this.getBancoClip(lines);
    dataParsed.tipoCuenta = this.getTipoCuentaClip(lines);

    console.log('---------------');
    console.log(lines);

    return dataParsed;
  }

  /* Funciones de extracción de datos (modificadas para retornar valores) */
  private getRazonSocial(lines: string[]) {        
       let result = '-'
        if ( !lines ||  lines.length === 0){
          return result;
        }
          const line = lines[0] ;
          /**EMPRESA  */
          result= line.trim();
        //lines.splice(0, 1);
        return result;
  }
  private getNombresYApellidos(lines: string[]) {            
    const detalleNombre : {
     // nombreCompleto:string,
      nombre : {
          nombresTitular: string;
          primerApellido:string;
          segundoApellido:string;
        }
     }={
     // nombreCompleto: '-',
      nombre:{nombresTitular:'',primerApellido:'',segundoApellido:''}
     };
     if ( !lines ||  lines.length === 0){
       return detalleNombre.nombre;
     }

     const words = lines[0].trim().split(' ');
     if (words.length >= 2) {
          // detalleNombre.nombreCompleto = '';
         if (words.length === 2) {
          //  detalleNombre.nombreCompleto = words[0] + ' ' + words[1];
           detalleNombre.nombre.nombresTitular = words[0];
           detalleNombre.nombre.primerApellido = words[1];
         } else if (words.length === 3) {
          //  detalleNombre.nombreCompleto = words[0] + ' ' + words[1] + ' ' + words[2];
           detalleNombre.nombre.nombresTitular = words[0];
           detalleNombre.nombre.primerApellido = words[1];
           detalleNombre.nombre.segundoApellido = words[2];
         } else if (words.length === 4) {
          //  detalleNombre.nombreCompleto = words[0] + ' ' + words[1] + ' ' + words[2] + ' ' + words[3];
           detalleNombre.nombre.nombresTitular = words[0] + ' ' + words[1];
           detalleNombre.nombre.primerApellido = words[2];
           detalleNombre.nombre.segundoApellido = words[3];
         } else if (words.length === 5) {
          //  detalleNombre.nombreCompleto = words[0] + ' ' + words[1] + ' ' + words[2] + ' ' + words[3] + ' ' + words[4];
           detalleNombre.nombre.nombresTitular = words[0] + ' ' + words[1] + ' ' + words[2];
           detalleNombre.nombre.primerApellido = words[3];
           detalleNombre.nombre.segundoApellido = words[4];
         }
         //lines.splice(0, 1);
         return detalleNombre.nombre;  
      }
  }
  private getMailClip(lines: string[]) {
    for (let i = 0; i < lines.length; i++) {
      lines[i] = lines[i].replace('\r', '').trim();
      if (lines[i].match(/^[a-zA-Z0-9]{1,}[a-zA-Z0-9_\-\.~]*@[a-zA-Z0-9_\-\.~]{1,}\.[a-zA-Z]{2,4}$/)) {
        const email = lines[i];
        lines.splice(i, 1);
        return email;
      }
    }
    return '-';
  }

  private getRutClip(lines: string[]) {
    for (let i = 0; i < lines.length; i++) {
       const aux =  lines[i].split('.').join('');
      if (aux.match(/^[0-9]+[-|‐]{1}[0-9kK]{1}$/)) {
        const rut = lines[i];
        lines.splice(i, 1);
        return rut;
      }
    }
    return '-';
  }


  private getCuentaClip(lines: string[]) {
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].toString().replace(/\D/g, '');
      if (line.length > 0 && !isNaN(Number(line))) {
        const cuenta = line;
        lines.splice(i, 1);
        return cuenta;
      }
    }
    return '-';
  }

  private getBancoClip(lines: string[]) {
    for (const line of lines) {
      const banco = this.datosBanco.find(b => line.toLowerCase().includes(b.asString.toLowerCase()));
      if (banco) return { id: banco.id, descripcion: banco.asString };
    }
    return { id: 0, descripcion: '-' };
  }


  private getTipoCuentaClip(lines: string[]):TipoCuenta {
    for (const line of lines) {
      const tipoCuenta = this.tiposCuentasDefinidos.find(tc => line.toLowerCase().includes(tc.descripcion.toLowerCase()));
      if (tipoCuenta) return tipoCuenta;
    }
    return undefined;
  }





}